import React, { useContext, useEffect, useState } from 'react';
import { db } from 'src/firebase';
import { collection, getDocs, query, addDoc, doc, deleteDoc } from 'firebase/firestore';
import { Pane, Text, Card, Dialog, DrawIcon, Button, EditIcon, DeleteIcon, PlusIcon, TextInputField } from 'evergreen-ui';
import { Loading } from 'src/components';
import { useNavigate } from 'react-router-dom';
import AuthContext from 'src/providers/authProvider';
import useRedirectIfNotAuthorized from 'src/hooks/useIsAdminWithRedirect';
import Layout from 'src/layouts/Default';
import '../styles.css'

const Emails = () => {
  const navigate = useNavigate();
  const { loading } = useContext(AuthContext);
  useRedirectIfNotAuthorized();
  const [createModalIsOpen, setCreateModalIsOpen] = useState(false);
  const [nameField, setNameField] = useState('');
  const [emails, setEmails] = useState([]);
  const [areEmailsLoading, setAreEmailsLoading] = useState(true);
  const getEmails = async () => {
    const q = await query(collection(db, 'emails'));
    const snapshot = await getDocs(q);
    setEmails(snapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    setAreEmailsLoading(false);
  };

  useEffect(() => {
    getEmails();
  }, []);

  if (loading || areEmailsLoading) {
    return <Loading />;
  }

  const onGoBack = () => {
    window.history.back();
  };

  const onCreateNewEmail = async () => {
    const { id } = await addDoc(collection(db, 'emails'), {
      name: nameField,
    });

    navigate(`/admin/emails/${id}`);
  };

  const onEditEmail = (id) => {
    navigate(`/admin/emails/${id}`);
  };

  const onDeleteEmail = async (id) => {
    const docRef = doc(db, 'emails', id);
    await deleteDoc(docRef);
    getEmails();
  };

  return (
    <Layout title="Email Drafts" actionButtonProps={{ onBack: onGoBack }} maxWidth={720}>
      <Dialog
        isShown={createModalIsOpen}
        title="Enter a name for your email draft"
        onCloseComplete={() => setCreateModalIsOpen(false)}
        confirmLabel="Create"
        onConfirm={onCreateNewEmail}
      >
        <TextInputField placeholder="Email draft name" value={nameField} onChange={(e) => setNameField(e.target.value)} />
      </Dialog>
      <Card elevation={1} padding="30px" width={720} maxWidth="100%" display="flex" flexDirection="column" gap="24px" wordBreak="break-all">
        <Pane display="flex" flex="1" justifyContent="flex-end" width="100%">
          <Button appearance="primary" iconAfter={PlusIcon} onClick={() => setCreateModalIsOpen(true)}>
            Create
          </Button>
        </Pane>
        {emails.map((email) => (
          <Pane key={email.id} display="flex" alignItems="center" gap="24px" justifyContent="space-between" flexWrap="wrap">
            <Pane display="flex" alignItems="center" gap="12px">
              <DrawIcon size={16} />
              <Text>{email.name || 'No name'}</Text>
            </Pane>
            <Pane display="flex" alignItems="center" gap="8px">
              <Button iconAfter={EditIcon} onClick={() => onEditEmail(email.id)}>
                Edit
              </Button>
              <Button intent="danger" iconAfter={DeleteIcon} onClick={() => onDeleteEmail(email.id)}>
                Delete
              </Button>
            </Pane>
          </Pane>
        ))}
      </Card>
    </Layout>
  );
};

export default Emails;
